import { memo } from 'react';
import Svg, { Polygon } from 'react-native-svg';
import { aiColors, tint } from '../../../../ai-suite/theme';

const kBox = 200;
const kRadius = 70;

/** The polygon of scores (0–100) on spokes clockwise from the top. */
function pointsOf(values: number[]): string {
  return values
    .map((value, i) => {
      const angle = (Math.PI * 2 * i) / values.length - Math.PI / 2;
      const r = (Math.max(0, Math.min(value, 100)) / 100) * kRadius;
      const x = kBox / 2 + r * Math.cos(angle);
      const y = kBox / 2 + r * Math.sin(angle);
      return `${x.toFixed(1)},${y.toFixed(1)}`;
    })
    .join(' ');
}

/**
 * The areas' shape, unlabelled beside their bars: the outer ring is 100,
 * the inner 50; the last attempt shows dashed behind this one.
 */
export const AreaRadar = memo(
  ({
    scores,
    previous,
    size,
  }: {
    scores: number[];
    /** Aligned with `scores`; null when there was no attempt before. */
    previous: number[] | null;
    size: number;
  }) => (
    <Svg width={size} height={size} viewBox={`0 0 ${kBox} ${kBox}`}>
      {[100, 50].map(ring => (
        <Polygon
          key={ring}
          points={pointsOf(scores.map(() => ring))}
          fill="none"
          stroke={aiColors.border}
          strokeWidth={1}
        />
      ))}
      {previous ? (
        <Polygon
          points={pointsOf(previous)}
          fill={tint(aiColors.mutedForeground, 0.1)}
          stroke={aiColors.mutedForeground}
          strokeWidth={1.5}
          strokeDasharray="4 3"
        />
      ) : null}
      <Polygon
        points={pointsOf(scores)}
        fill={tint(aiColors.primary, 0.15)}
        stroke={aiColors.primary}
        strokeWidth={2}
      />
    </Svg>
  ),
);
